/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import Select from "react-select";
import Input from "components/Input";
import { useForm, FormProvider, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import apiService from "services/apiService";
import moment from "moment";
import monthData from "./newData";
import { getEpochTime, inUtc } from "util/epochTime";
import { sortByKey } from "util/sortOptions";
import { useAppContext } from "contexts/useAppContext";
import { useToaster } from "contexts/toasterContext";
import { customSelectStyles } from "util/selectStyles";
import { validateNoLeadingTrailingWhitespace } from "util/validation";
import { mergeProjectIds } from "util/projectIds";

interface IFormInput {
  projects: string;
  date: string;
  Hours: number;
  task: string;
}

const validationSchema = yup.object({
  projects: yup.string().required("Project required"),
  date: yup.string().required("Date is required"),
  Hours: yup
    .number()
    .typeError("Hours must be a number")
    .positive("Hours must be greater than zero")
    .required("Hours is required")
    .max(15, "Hours must be 15 or less"),
  task: yup.string()
    .required("Task is required")
    .test(
      "not-only-spaces",
      "Task cannot be empty spaces", // Updated error message
      validateNoLeadingTrailingWhitespace
    )
    .max(1000, "Project Details cannot be more than 1000 characters"),
});

const hasEntryForProjectOnDay = (data: any, projectId: any, day: number) =>
  Boolean(
    data?.data?.some(
      (project: any) =>
        String(project.projectId) === String(projectId) &&
        project.detail?.some(
          (detail: any) => Number(detail.day) === day && detail.task?.trim()
        )
    )
  );

interface IProps {
  projects: Array<any>;
  selectedProj: any;
  selectedUser: any;
  month: string;
  year: string;
  onClose: () => void;
  wholeData: any;
  setRefresh: any;
  refresh: number;
  selectedDate: any;
}

const AddTimeSheet = ({
  projects,
  selectedProj,
  selectedUser,
  month,
  year,
  onClose,
  wholeData,
  setRefresh,
  refresh,
  selectedDate,
}: IProps) => {
  const [selectedProject, setSelectedProject] = useState<string | null>(
    selectedProj
  );
  const [date, setDate] = useState("");
  const { user } = useAppContext();
  const { addToast } = useToaster();
  const defaultValues = {
    projects: selectedProj || "",
    date: moment(selectedDate).format("YYYY-MM-DD"),
    Hours: undefined,
    task: "",
  };
  const methods = useForm<IFormInput>({
    //@disable-next-line @typescript-eslint/no-explicit-any
    resolver: yupResolver(validationSchema) as any,
    mode: "onChange",
    defaultValues: defaultValues,
    reValidateMode: "onChange",
  });

  const {
    formState: { isDirty, isSubmitting },
  } = methods;

  useEffect(() => {
    const newdate = moment(selectedDate).format("YYYY-MM-DD");
    setDate(newdate);
    methods.reset({
      projects: selectedProj || "",
      date: newdate,
      Hours: undefined,
      task: "",
    });
  }, []);

  const TempPro: { value: any; label: any }[] =
    projects && projects.length > 0
      ? projects.map((project: any) => ({
        value: project.projectId,
        label: project.name,
      }))
      : [];
  const projectOptions = sortByKey(TempPro, "label");



  const handleProjectChange = (selectedOption: any) => {
    console.log("selectedOption :>> ", selectedOption);
    const nextProject = selectedOption?.value ?? "";
    const initialProject = selectedProj || "";
    const hasChanged = String(nextProject) !== String(initialProject);

    setSelectedProject(nextProject);
    methods.setValue("projects", nextProject, {
      shouldDirty: hasChanged,
      shouldValidate: true,
    });
  };

  useEffect(() => {
    methods.setValue("projects", selectedProj || methods.getValues().projects);
    methods.setValue("date", date || methods.getValues().date);
  }, [methods]);

  function extractDay(dateString: string | number) {
    const date =
      typeof dateString === "number"
        ? new Date(dateString)
        : new Date(Number(dateString));

    if (isNaN(date.getTime())) {
      console.warn("Invalid date in extractDay:", dateString);
      return new Date().getDate();
    }

    return date.getDate();
  }

  function extractMonth(dateInput: string | number) {
    const date =
      typeof dateInput === "number"
        ? new Date(dateInput)
        : new Date(Number(dateInput));
    if (isNaN(date.getTime())) {
      console.warn("Invalid date in extractMonth:", dateInput);
      return "";
    }
    return moment(date).format("MMM");
  }

  function extractYear(dateString: string | number) {
    const date =
      typeof dateString === "number"
        ? new Date(dateString)
        : new Date(Number(dateString));
    console.log("date :>> ", date);
    if (isNaN(date.getTime())) {
      console.warn("Invalid date in extractMonth:", dateString);
      return "";
    }
    return moment(date).format("YYYY");
  }

  function updateField({ wholeData, selectedProject, newValues }: any) {
    console.log("wholeData:>> ", wholeData, selectedProject, newValues);
    if (wholeData.data) {
      let projectFound = false;
      for (const project of wholeData.data) {
        if (project.projectId === selectedProject) {
          projectFound = true;
          console.log("first loop :>>>");

          project.detail = project.detail.filter(
            (detail: any) => detail.day != newValues.day
          );

          const ValuesA = {
            ...newValues,
            id: "",
            comment: newValues.comment || "",
            submitDate: newValues.submitDate || getEpochTime(new Date()),
            userName: user.displayName,
          };
          console.log("ValuesA :>> ", ValuesA);
          project.detail.push(ValuesA);
          console.log("project", project);
          break;
        }
      }

      if (!projectFound) {
        console.log("Project not found, adding new project.");
        const newProject = {
          projectId: selectedProject,
          detail: [
            {
              ...newValues,
              comment: newValues.comment || "",
              submitDate: newValues.submitDate || getEpochTime(new Date()),
              userName: user.displayName,
            },
          ],
          comment: "",
          status: "InProgress",
          totalHour: newValues.hour,
        };
        wholeData.data.push(newProject);
      }

      return wholeData;
    } else {
      console.log("third condition:>>>>>>>>>>");
      const newWholeData = {
        email: selectedUser,
        status: "InProgress",
        projectIds: `${selectedProject}`,
        comment: "",
        isNew: true,
        data: [
          {
            projectId: selectedProject,
            detail: [
              {
                ...newValues,
                comment: newValues.comment || "",
                submitDate: newValues.submitDate || getEpochTime(new Date()),
                userName: user.displayName,
              },
            ],
            comment: newValues.comment || "",
            status: "InProgress",
            totalHour: newValues.hour,
          },
        ],
      };
      return newWholeData;
    }
  }

  const onSubmit = async (data: any) => {
    const submitDate = new Date();
    const dateINUtc = inUtc(data.date);

    const dateInEpoch = getEpochTime(dateINUtc) * 1000;

    console.log("selected Date : ", data.date);
    console.log("Date in UTC ", dateINUtc);
    console.log("Date in EPOCH ", dateInEpoch);

    const formattedSubmitDate = getEpochTime(submitDate) * 1000;
    console.log("Submitted Date ", formattedSubmitDate);

    const newValues = {
      day: Number(extractDay(dateInEpoch)),
      task: data.task.trim(),
      hour: data.Hours,
      comment: "",
      submitDate: formattedSubmitDate,
      date: dateInEpoch,
    };

    if (hasEntryForProjectOnDay(wholeData, selectedProject, newValues.day)) {
      addToast(
        "A timesheet already exists for this project on this date. Click its entry in the calendar to edit it.",
        "error"
      );
      return;
    }

    const value = updateField({ wholeData, selectedProject, newValues });
    value.month = extractMonth(dateInEpoch.toString());
    value.year = extractYear(dateInEpoch.toString());
    // Keep the existing pipe-delimited projectIds and add the selected project
    // only if it is not already present (never drop an existing id).
    value.projectIds = mergeProjectIds(value.projectIds, selectedProject);
    value.submitDate = formattedSubmitDate;
    value.userName = user.displayName;
    console.log("value :>>", value);

    if (!value.isNew) {
      try {
        const res = await apiService.put(`api/timesheet/${value.id}`, value);
        console.log("res", res);
        setRefresh(refresh + 1);
        addToast("Timesheet Added successfully", "success");
        onClose();
      } catch (err) {
        console.log("err :>> ", err);
      }
    } else {
      const payloadData: Array<any> = projects.map((project) => {
        const payload: any = {
          projectId: project.projectId,
          projectName: project.name,
          detail: monthData,
          comment: "",
          status: "InProgress",
          totalHour: data.Hours,
        };
        payload.totalHour = data.Hours;
        return payload;
      });

      const wholeData = {
        email: selectedUser,
        comment: "",
        year: year,
        month: month,
        status: "InProgress",
        totalHour: data.Hours,
        submitDate: formattedSubmitDate,
        projectIds: selectedProject,
        userName: user.displayName,
        data: [...payloadData],
      };

      console.log("post :>", wholeData);
      const newValue1 = updateField({ wholeData, selectedProject, newValues });
      console.log("newValue1  post new ==>", newValue1);

      try {
        const res = await apiService.post(`api/timesheet`, newValue1);
        if (res.status === 200 || res.status === 201) {
          setRefresh(refresh + 1);
          addToast("Timesheet Added successfully", "success");
          onClose();
          console.log("res created:>> ", res);
        } else {
          console.log("error");
        }
      } catch (err) {
        console.log("err", err);
        addToast(err.response.data, "error")
      }
    }
  };

  const handleDateChange = (e: any) => {
    setDate(e.target.value);
    methods.setValue("date", e.target.value);
  };

  return (
    <div className="space-y-6 md:grid-cols-2">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <div className="grid gap-6 mb-1 md:grid-cols-2">
            <div className="form-group mb-1">
              <label
                htmlFor="project"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Select Project<span className="text-red-500"> *</span>
              </label>

              <Select
                name="projects"
                options={projectOptions}
                value={projectOptions.find(
                  (option) => option.value === selectedProject
                )}
                className="select"
                styles={customSelectStyles}
                onChange={handleProjectChange}
                menuPosition="fixed"
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              />

              {methods.formState.errors.projects && (
                <span className="text-red-500 text-sm mt-1 block min-h-[20px]">
                  {methods.formState.errors.projects.message as string}
                </span>
              )}
            </div>
            <div className="grid gap-6 mb-1 md:grid-cols-2">
              <div>
                <Input
                  type="date"
                  label="Date"
                  name="Date"
                  disabled={true}
                  onChange={handleDateChange}
                  value={date}
                />
              </div>
              <div>
                <Controller
                  name="Hours"
                  control={methods.control}
                  render={({ field: { onChange, value } }) => (
                    <Input
                      name="Hours"
                      label="Hours"
                      type="number"
                      // step="0.01" // Required for HTML5 forms to allow decimals
                      placeholder="Eg: 8"
                      onChange={(e: any) => {
                        let rawValue = e?.target?.value;

                        // Check if a decimal exists in the typed string
                        if (rawValue.includes(".")) {
                          const [integerPart, decimalPart] = rawValue.split(".");

                          // If the user types more than 2 digits after the decimal, cut it off
                          if (decimalPart.length > 2) {
                            rawValue = `${integerPart}.${decimalPart.slice(0, 2)}`;
                            e.target.value = rawValue; // Force the input UI to show the cut-off value
                          }
                        }

                        // Pass the sanitized value to React Hook Form
                        onChange(rawValue === "" ? undefined : Number(rawValue));
                      }}
                      value={value ?? ""}
                      required
                    />
                  )}
                />
              </div>
            </div>
          </div>

          <Input
            type="textarea"
            label="Task"
            name="task"
            placeholder="Worked on Sample task"
            required
          />

          {/* <div className="flex justify-end items-center p-4 md:p-5 border-t border-gray-200 rounded-b"> */}
          <button
            type="button"
            onClick={onClose}
            className="ms-3 text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900"
          >
            Cancel
          </button>

          <button
            type="submit"
            disabled={!isDirty || isSubmitting}
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 ms-3 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            Add
          </button>
          {/* </div> */}
        </form>
      </FormProvider>
    </div>
  );
};

export default AddTimeSheet;